import _classCallCheck from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _objectSpread from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["pixelDensities"],
    _excluded2 = ["widths"];

var camelCaseToParamCase = function camelCaseToParamCase(input) {
  return input.replace(/[A-Z]/g, function (match) {
    return "-".concat(match.toLowerCase());
  });
};

var buildURL = function buildURL(url, params) {
  var instance = new URL(url);

  for (var camelCasedParamKey in params) {
    var paramKey = camelCaseToParamCase(camelCasedParamKey);
    var paramValue = params[camelCasedParamKey];

    if (paramValue === void 0) {
      instance.searchParams.delete(paramKey);
    } else if (Array.isArray(paramValue)) {
      instance.searchParams.set(paramKey, paramValue.join(","));
    } else {
      instance.searchParams.set(paramKey, "".concat(paramValue));
    }
  }

  var s = instance.searchParams.get("s");

  if (s) {
    instance.searchParams.delete("s");
    instance.searchParams.append("s", s);
  }

  return instance.toString();
};

var buildPixelDensitySrcSet = function buildPixelDensitySrcSet(url, _ref) {
  var pixelDensities = _ref.pixelDensities,
      params = _objectWithoutProperties(_ref, _excluded);

  return pixelDensities.map(function (dpr) {
    return "".concat(buildURL(url, _objectSpread(_objectSpread({}, params), {}, {
      dpr: dpr
    })), " ").concat(dpr, "x");
  }).join(", ");
};

var buildWidthSrcSet = function buildWidthSrcSet(url, _ref2) {
  var widths = _ref2.widths,
      params = _objectWithoutProperties(_ref2, _excluded2);

  return widths.map(function (width) {
    return "".concat(buildURL(url, _objectSpread(_objectSpread({}, params), {}, {
      w: void 0,
      width: width
    })), " ").concat(width, "w");
  }).join(", ");
};

var Client = /*#__PURE__*/function () {
  function Client(options) {
    _classCallCheck(this, Client);

    this.baseURL = options.baseURL;
  }

  _createClass(Client, [{
    key: "buildURLForPath",
    value: function buildURLForPath(path) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return buildURL("".concat(new URL(path, this.baseURL)), params);
    }
  }, {
    key: "buildWidthSrcSetForPath",
    value: function buildWidthSrcSetForPath(path, params) {
      return buildWidthSrcSet("".concat(new URL(path, this.baseURL)), params);
    }
  }, {
    key: "buildPixelDensitySrcSetForPath",
    value: function buildPixelDensitySrcSetForPath(path, params) {
      return buildPixelDensitySrcSet("".concat(new URL(path, this.baseURL)), params);
    }
  }]);

  return Client;
}();

export { Client, buildPixelDensitySrcSet, buildURL, buildWidthSrcSet };